import { composeIO } from 'react-compose-io'
import { boxValoresIO } from './BoxValores.IO'
import BoxValoresView from './BoxValores.View'

export const BoxValores = composeIO(BoxValoresView, boxValoresIO)
